import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { consulta, pedir } from '../api/nucleo'
import type { Lista } from '../api/tipos'
import { Escribenos } from '../componentes/Ayuda'
import { Aviso, Cargando } from '../componentes/ui'
import { Editor } from '../motor/Editor'

/**
 * Una colección con **un documento por web** (los ajustes): no hay lista que enseñar,
 * se abre el documento directamente. El documento lo crea el alta del sitio (§4): si
 * no está, algo falló al crear la web y se dice.
 */
export const Unico = ({ coleccion, sitio, espacio, base, cabecera }: { base: string; cabecera?: (valores: Record<string, unknown>) => ReactNode; coleccion: string; espacio: number; sitio: number }) => {
  const { data, isPending } = useQuery({
    queryKey: ['unico', coleccion, sitio],
    queryFn: async () => (await pedir<Lista<{ id: number }>>(`/${coleccion}${consulta({ 'where[sitio][equals]': sitio, limit: 1, depth: 0 })}`)).docs[0] ?? null,
  })
  if (isPending) return <Cargando que="Abriendo" />
  if (!data)
    return (
      <Aviso tono="error">
        Esta web no tiene su documento de ajustes. <Escribenos contexto="ajustes-sin-documento">Escríbenos</Escribenos> y lo arreglamos.
      </Aviso>
    )
  return <Editor base={base} cabecera={cabecera ? ({ valores }) => cabecera(valores) : undefined} coleccion={coleccion} espacio={espacio} id={data.id} puedeBorrar={false} sitio={sitio} />
}
